export function getStatusColor(bidStatus) {
  let statusColorClass = '';

  switch (bidStatus) {
    case 'openforbids':
      statusColorClass = 'bg-success';
      break;
    case 'notopen':
      statusColorClass = 'bg-warning';
      break;
    case 'closedforbids':
      statusColorClass = 'bg-danger';
      break;
    case 'lotterydrawn':
      statusColorClass = 'bg-danger';
      break;
    case 'lotteryredrawn':
      statusColorClass = 'bg-danger';
      break;
    default:
      statusColorClass = '';
  }

  return statusColorClass;
}
